<template>
  <dy-dialog v-model="visible" width="70%" title="选择科目" confirm-title="确定" :show-confirm="!!selectRow"
             @onConfirm="handleSelected" @onClose="handleClose">
    <dy-main-container class="select-asset-dialog" hide-top-menu>
      <template #left>
        <DyOrgManagement
          ref="leftTreeRef"
          :table-list-api="api.getChargeAccountTypeTree"
          data-path="data"
          @defaultSelected="handleOrgSelected"
          @onchange="handleOrgSelected"
          :width="dividerOption.leftAsideWidth"
          :table-columns="tableColumns"
        />
      </template>
      <template #right>
        <avue-crud ref="crud" :page.sync="page" :data="tableList" :table-loading="tableLoading"
                   :option="avueOption" @search-change="searchChange" @row-click="rowClick" @on-load="getList">
          <template slot="radio" slot-scope="{row}">
            <el-radio v-model="selectRowIndex" :label="row.$index">&nbsp;</el-radio>
          </template>
        </avue-crud>
      </template>
    </dy-main-container>
  </dy-dialog>
</template>

<script>
import DyDialog from "@/components/DYDialog/index.vue";
import DyMainContainer from "@/components/DYMainContainer/index.vue";
import {getTableOption} from '@/const/crud/charge/account/company';
import {getChargeAccountTypeTree} from "@/api/v3/finance/account/type";
import {chargeAccountList} from "@/api/v3/finance/account/company";

export default {
  name: 'DySelectAccountDialog',
  components: {DyMainContainer, DyDialog},
  data() {
    return {
      visible: false,
      assetType: 0,
      orgInfo: undefined,
      selectRow: undefined,
      selectRowIndex: undefined,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      dividerOption: {
        leftAsideWidth: 225,
        leftAsideMinWidth: 200
      },
      searchForm: {},
      api: {
        getChargeAccountTypeTree: () => getChargeAccountTypeTree({includeAccount: false, includeValid: true}),
      },
      avueOption: undefined,
      tableList: undefined,
      tableLoading: false,
      tableColumns: [
        {
          label: '名称',
          prop: 'name',
          width: '70',
          mainColumn: true,
        },
      ],
      extraSearchParams: undefined
    }
  },
  methods: {
    open(params) {
      const {searchParams, resolve, cancel} = params || {}
      this.extraSearchParams = searchParams
      this.resolve = resolve
      this.cancel = cancel
      const avueOption = getTableOption()
      avueOption.menu = false
      avueOption.index = false
      avueOption.height = 380
      avueOption.searchSpan = 6
      avueOption.searchMenuSpan = 24
      const columns = ['code', 'name', 'pid', 'enableStatusDisaccount', 'enableLatefee', 'enableInvoice', 'invoiceTaxRate', 'enableLatefee', 'latefeeChargeRatio']
      avueOption.column = avueOption.column.filter(item => {
        return columns.includes(item.prop)
      })
      avueOption.column.unshift({
        prop: 'radio',
        width: 60,
      })
      this.avueOption = avueOption
      this.visible = true
    },
    handleOrgSelected(org) {
      this.orgInfo = org
      this.getList()
    },
    searchChange(form, done) {
      this.searchForm = form
      this.getList()
      done()
    },
    async getList() {
      this.tableLoading = true
      const form = {
        ...this.searchForm,
        page: this.page.currentPage,
        limit: this.page.pageSize,
        pid: this.orgInfo?.id,
        enabled: 1,
        ...this.extraSearchParams
      }
      const res = await chargeAccountList(form)
      this.tableList = res.data.records
      this.page.total = Number(res.data.total)
      this.tableLoading = false
    },
    handleSelected() {
      this.visible = false
      this.$emit('confirm', this.selectRow)
      this.resolve && this.resolve(this.selectRow)
    },
    handleClose() {
      this.cancel && this.cancel()
    },
    rowClick(row) {
      this.selectRow = row
      this.selectRowIndex = row.$index
    }
  }

}
</script>

<style scoped lang="scss">

.select-asset-dialog {
  height: 570px;
  overflow: hidden;
}

::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgba(236, 236, 236, 0.89);
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(236, 236, 236, 0.89);
  }
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
